<template>
  <div class="customer-phone-number-verify-dialog-container" v-if="show">
    <loading :loading="loading"></loading>
    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box" :style="{top:top+'px', left: left+'px', right: right + 'px'}">
      <div class="dialog-content-without-cross">

        <weex-text class="item-heading">{{message}}</weex-text>

        <div class="input_container">
          <weex-text class="input_label">Phone Number</weex-text>
          <div class="item-phone-number-input-container margin-top-5">

            <phone-code-item
                :enabled-phone-code-selection="false"
                :default-country-code="getSelectedPhoneCode"
            ></phone-code-item>

            <input
              class="item-phone-number-input"
              :value="phoneNumber"
              :disabled="true" />
          </div>
        </div>

        <div
          v-if="showPhoneNumberVerifyButtonsDiv"
          class="margin-top-30">
          <wxc-button
            text="Send OTP"
            class="horizontal_center"
            type="blue"
            @wxcButtonClicked="onSendSMSOtpClicked"
          ></wxc-button>
        </div>

        <s-m-s-o-t-p-view
          ref="smsOTPView"
          :show="showSMSOTPView"
          login-text="Submit OTP"
          @onLoginClicked="onLoginWithSMSOTPClicked($event.otp)"
          @onCallAndVerifyClicked="onCallAndVerifyClicked"
          @onSendOTPClicked="onSendSMSOtpClicked"
        ></s-m-s-o-t-p-view>

        <call-and-verify-view
          :show="showCallAndVerifyView"
          login-text="Continue"
          :call-and-verify-message="callAndVerifyMessage"
          :otp="generatedOTP"
          @onLoginClicked="onLoginWithCallAndVerifyClicked"
          @onVerifyWithSMSOTPClicked="onSendSMSOtpClicked"
        ></call-and-verify-view>
      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";
import AlertService from "../core/alert/AlertService";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import DataSource from "../../data/DataSource";
import Loading from "../layout/Loading";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import NetworkErrorUtil from "../../utils/NetworkErrorUtil";
import { environment } from "../../environments/environment";
import SMSOTPView from "../layout/SMSOTPView";
import CallAndVerifyView from "../layout/CallAndVerifyView";
import PhoneCodeItem from "@/components/layout/PhoneCodeItem";
import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

export default {
  components: {
    WxcOverlay,
    WxcButton,
    Loading,
    ErrorAlertItem,
    SMSOTPView,
    CallAndVerifyView,
    PhoneCodeItem
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    top: {
      type: Number,
      default: 20
    },
    left: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    smsType: "",
    message: "",
    phoneNumber: "",
    officeExternalId: "",
    officeId: -1,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    smsOTPId: -1,
    generatedOTP: "",
    generatedOTPId: -1,
    verifiedOTP: "",
    showPhoneNumberVerifyButtonsDiv: true,
    showCallAndVerifyView: false,
    showSMSOTPView: false
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    resetData() {
      this.smsOTPId = -1;
      this.generatedOTP = "";
      this.generatedOTPId = -1;
      this.showPhoneNumberVerifyButtonsDiv = true;
      this.showSMSOTPView = false;
      this.showCallAndVerifyView = false;
    },

    verifyPhoneNumber(phoneNumber, smsType, message, officeId, officeExternalId) {
      this.resetData();
      this.smsType = smsType;
      this.phoneNumber = phoneNumber;
      this.message = message;
      this.officeId = officeId;
      this.officeExternalId = officeExternalId;
    },

    onSendSMSOtpClicked() {
      this.loading = true;
      DataSource.sendOTPWithAuth(
        this.phoneNumber,
        this.smsType,
        this.officeId,
        this.officeExternalId
      )
        .then(smsOTPRes => {
          this.loading = false;
          if (smsOTPRes.errorOccurred) {
            this.showError(smsOTPRes.data);
          } else {
            this.showPhoneNumberVerifyButtonsDiv = false;
            this.smsOTPId = smsOTPRes.data.id;
            this.showCallAndVerifyView = false;
            this.showSMSOTPView = true;
            this.showToast(MessageConstants.OTP_SENT_MESSAGE);
            this.$refs.smsOTPView.showSMSOTPView();
          }
        })
    },

    onCallAndVerifyClicked() {
      this.loading = true;
      DataSource.generateOTP(this.phoneNumber)
        .then(generatedOTPRes => {
          this.loading = false;
          if (generatedOTPRes.errorOccurred) {
            this.showError(NetworkErrorUtil.getNetworkIssueDetails(generatedOTPRes.data));
          } else {
            const generatedOTPData = generatedOTPRes.data ? generatedOTPRes.data : {};
            this.showPhoneNumberVerifyButtonsDiv = false;
            this.generatedOTP = generatedOTPData.otp ? generatedOTPData.otp.toString() : "";
            this.generatedOTPId = generatedOTPRes.data.id;
            this.showSMSOTPView = false;
            this.showCallAndVerifyView = true;
          }
        })
    },

    onLoginWithSMSOTPClicked(otp) {
      this.loading = true;
      DataSource.verifyOTP(this.phoneNumber, otp)
        .then(verifyOTPRes => {
          this.loading = false;
          if (verifyOTPRes.errorOccurred) {
            this.showError(verifyOTPRes.data);
          } else {
            this.verifiedOTP = otp;
            this.getVerificationStatus(this.smsOTPId);
          }
        })
    },

    onLoginWithCallAndVerifyClicked() {
      this.verifiedOTP = this.generatedOTP;
      this.getVerificationStatus(this.generatedOTPId);
    },

    getVerificationStatus(otpId) {
      this.loading = true;
      DataSource.getOTPVerificationStatus(otpId)
        .then(otpVerificationStatusRes => {
          this.loading = false;
          if (otpVerificationStatusRes.errorOccurred) {
            this.showError(otpVerificationStatusRes.data);
          } else {
            const statusData = otpVerificationStatusRes.data ? otpVerificationStatusRes.data : {};
            if ("VERIFIED" === statusData.status) {
              this.onPhoneNumberVerified();
            } else {
              this.showToast("Phone Number is not verified.");
            }
          }
        })
    },

    onPhoneNumberVerified() {
      this.$emit(
        "onPhoneNumberVerified",
        { phoneNumber: this.phoneNumber, verifiedOTP: this.verifiedOTP }
      );
    }
  },

  computed: {
    callAndVerifyMessage() {
      return `Please call <b>${environment.callAndVerifyMobile}</b> from <b>${this.phoneNumber}</b> and enter the below OTP.`;
    },

    getSelectedPhoneCode() {
      return LoanScopeDataHolder.getPhoneCode();
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.customer-phone-number-verify-dialog-container {
  position: fixed;
  z-index: 9999;
}
</style>
